import styled from 'styled-components'

import { Text, H3 } from 'components/common'
import { COLOR } from 'styles/constants'

export const WizardStep = styled(Text).attrs({ className: 'wizard-step' })`
  line-height: 28px;
  height: 28px;
  font-size: 16px;
  margin-bottom: 8px;
  color: ${COLOR.GREY_LV1};
  display: block;
`

export const WizardTitle = styled(H3).attrs({ className: 'wizard-title' })`
  margin-bottom: 16px;
`

export const WizardSubSectionText = styled(H3).attrs({
  className: 'contact-agent-sub-section',
})<typeof H3 & { $hide?: boolean }>`
  display: ${(props) => (props.$hide ? 'none' : 'block')};

  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
  margin-top: -8px;

  span {
    color: ${COLOR.GREY_UNDEFINED};
    font-weight: 600;
  }
`
